module.exports = __webpack_public_path__ + "static/media/LD.55ee628c.svg";